"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const baseUrl = localStorage.getItem('baseUrl');
exports.axiosInstance = axios_1.default.create({
    baseURL: baseUrl
});
const token = localStorage.getItem('appJWT') || '';
const setUpToken = () => {
    if (token) {
        exports.axiosInstance.defaults.headers.common.Authorization = `Bearer ${token.toString()}`;
    }
    else {
        delete exports.axiosInstance.defaults.headers.common.Authorization;
    }
};
setUpToken();
